import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus, Edit, Trash2, Eye, Users, Briefcase, DollarSign, MapPin, Clock } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/Table';
export function JobManagementPage() {
  const navigate = useNavigate();
  const [selectedJob, setSelectedJob] = useState<number | null>(null);
  const jobs = [{
    id: 1,
    title: 'Frontend Developer',
    type: 'Full-time',
    location: 'Jakarta',
    salary: 'Rp 8-12 juta',
    applicants: 15,
    status: 'active',
    posted: '5 hari lalu',
    views: 234
  }, {
    id: 2,
    title: 'Backend Developer',
    type: 'Full-time',
    location: 'Remote',
    salary: 'Rp 10-15 juta',
    applicants: 23,
    status: 'active',
    posted: '3 hari lalu',
    views: 456
  }, {
    id: 3,
    title: 'UI/UX Designer',
    type: 'Contract',
    location: 'Bandung',
    salary: 'Rp 7-10 juta',
    applicants: 8,
    status: 'active',
    posted: '1 minggu lalu',
    views: 189
  }, {
    id: 4,
    title: 'DevOps Engineer',
    type: 'Full-time',
    location: 'Jakarta',
    salary: 'Rp 12-18 juta',
    applicants: 12,
    status: 'closed',
    posted: '2 minggu lalu',
    views: 312
  }, {
    id: 5,
    title: 'Mobile Developer',
    type: 'Freelance',
    location: 'Remote',
    salary: 'Rp 8-12 juta',
    applicants: 19,
    status: 'draft',
    posted: 'Draft',
    views: 0
  }];
  const stats = [{
    label: 'Total Lowongan',
    value: jobs.length.toString(),
    icon: Briefcase,
    color: 'text-atios-primary',
    bgColor: 'bg-atios-light'
  }, {
    label: 'Lowongan Aktif',
    value: jobs.filter(j => j.status === 'active').length.toString(),
    icon: Clock,
    color: 'text-success',
    bgColor: 'bg-success-light'
  }, {
    label: 'Total Pelamar',
    value: jobs.reduce((sum, j) => sum + j.applicants, 0).toString(),
    icon: Users,
    color: 'text-warning',
    bgColor: 'bg-warning-light'
  }, {
    label: 'Total Views',
    value: jobs.reduce((sum, j) => sum + j.views, 0).toString(),
    icon: Eye,
    color: 'text-neutral-700',
    bgColor: 'bg-neutral-100'
  }];
  const handleDelete = (jobId: number) => {
    if (confirm('Apakah Anda yakin ingin menghapus lowongan ini?')) {
      alert(`Lowongan #${jobId} berhasil dihapus`);
    }
  };
  return <div className="min-h-screen bg-white" data-id="element-2085">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-2086">
        {/* Header */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-8" data-id="element-2087">
          <div data-id="element-2088">
            <h1 className="text-3xl font-semibold text-neutral-900 mb-2" data-id="element-2089">
              Kelola Lowongan Kerja
            </h1>
            <p className="text-neutral-600" data-id="element-2090">
              Kelola lowongan kerja perusahaan Anda
            </p>
          </div>
          <Button onClick={() => navigate('/jobs/create')} data-id="element-2091">
            <Plus className="w-4 h-4 mr-2" data-id="element-2092" />
            Buat Lowongan Baru
          </Button>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8" data-id="element-2093">
          {stats.map((stat, i) => <Card key={i} data-id="element-2094">
              <CardContent className="p-6" data-id="element-2095">
                <div className="flex items-center gap-4" data-id="element-2096">
                  <div className={`p-3 rounded-lg ${stat.bgColor}`} data-id="element-2097">
                    <stat.icon className={`w-6 h-6 ${stat.color}`} data-id="element-2098" />
                  </div>
                  <div data-id="element-2099">
                    <p className="text-2xl font-semibold text-neutral-900" data-id="element-2100">
                      {stat.value}
                    </p>
                    <p className="text-sm text-neutral-600" data-id="element-2101">{stat.label}</p>
                  </div>
                </div>
              </CardContent>
            </Card>)}
        </div>

        {/* Jobs Table */}
        <Card data-id="element-2102">
          <CardHeader data-id="element-2103">
            <CardTitle data-id="element-2104">Daftar Lowongan</CardTitle>
          </CardHeader>
          <CardContent data-id="element-2105">
            <Table data-id="element-2106">
              <TableHeader data-id="element-2107">
                <TableRow data-id="element-2108">
                  <TableHead data-id="element-2109">Posisi</TableHead>
                  <TableHead data-id="element-2110">Tipe</TableHead>
                  <TableHead data-id="element-2111">Lokasi</TableHead>
                  <TableHead data-id="element-2112">Gaji</TableHead>
                  <TableHead data-id="element-2113">Pelamar</TableHead>
                  <TableHead data-id="element-2114">Views</TableHead>
                  <TableHead data-id="element-2115">Status</TableHead>
                  <TableHead data-id="element-2116">Diposting</TableHead>
                  <TableHead className="text-right" data-id="element-2117">Aksi</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody data-id="element-2118">
                {jobs.map(job => <TableRow key={job.id} data-id="element-2119">
                    <TableCell className="font-medium text-neutral-900" data-id="element-2120">
                      {job.title}
                    </TableCell>
                    <TableCell data-id="element-2121">
                      <Badge variant="default" className="text-xs" data-id="element-2122">
                        {job.type}
                      </Badge>
                    </TableCell>
                    <TableCell className="text-neutral-600" data-id="element-2123">
                      <div className="flex items-center gap-1" data-id="element-2124">
                        <MapPin className="w-3 h-3" data-id="element-2125" />
                        {job.location}
                      </div>
                    </TableCell>
                    <TableCell className="text-neutral-600" data-id="element-2126">
                      <div className="flex items-center gap-1" data-id="element-2127">
                        <DollarSign className="w-3 h-3" data-id="element-2128" />
                        {job.salary}
                      </div>
                    </TableCell>
                    <TableCell className="text-neutral-900 font-medium" data-id="element-2129">
                      {job.applicants}
                    </TableCell>
                    <TableCell className="text-neutral-600" data-id="element-2130">
                      {job.views}
                    </TableCell>
                    <TableCell data-id="element-2131">
                      <Badge variant={job.status === 'active' ? 'success' : job.status === 'closed' ? 'error' : 'default'} data-id="element-2132">
                        {job.status === 'active' ? 'AKTIF' : job.status === 'closed' ? 'TUTUP' : 'DRAFT'}
                      </Badge>
                    </TableCell>
                    <TableCell className="text-neutral-600 text-sm" data-id="element-2133">
                      {job.posted}
                    </TableCell>
                    <TableCell className="text-right" data-id="element-2134">
                      <div className="flex justify-end gap-2" data-id="element-2135">
                        <Button size="sm" variant="ghost" onClick={() => navigate(`/jobs/${job.id}`)} data-id="element-2136">
                          <Eye className="w-4 h-4" data-id="element-2137" />
                        </Button>
                        <Button size="sm" variant="ghost" onClick={() => navigate(`/jobs/${job.id}/edit`)} data-id="element-2138">
                          <Edit className="w-4 h-4" data-id="element-2139" />
                        </Button>
                        <Button size="sm" variant="ghost" onClick={() => handleDelete(job.id)} className="text-error hover:text-error" data-id="element-2140">
                          <Trash2 className="w-4 h-4" data-id="element-2141" />
                        </Button>
                      </div>
                    </TableCell>
                  </TableRow>)}
              </TableBody>
            </Table>
          </CardContent>
        </Card>

        {/* Quick Tips */}
        <Card className="mt-8 bg-atios-light border-atios-primary/20" data-id="element-2142">
          <CardContent className="p-6" data-id="element-2143">
            <div className="flex items-start gap-4" data-id="element-2144">
              <Briefcase className="w-6 h-6 text-atios-primary flex-shrink-0 mt-1" data-id="element-2145" />
              <div data-id="element-2146">
                <h3 className="font-semibold text-neutral-900 mb-2" data-id="element-2147">
                  Tips Membuat Lowongan Efektif
                </h3>
                <ul className="text-sm text-neutral-700 space-y-1 list-disc list-inside" data-id="element-2148">
                  <li data-id="element-2149">Tulis deskripsi pekerjaan yang jelas dan detail</li>
                  <li data-id="element-2150">Cantumkan range gaji yang kompetitif</li>
                  <li data-id="element-2151">Sebutkan benefit dan fasilitas yang ditawarkan</li>
                  <li data-id="element-2152">Update status lowongan secara berkala</li>
                </ul>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>;
}